import { withStyles } from "@material-ui/core/styles";
import Foto from "./Foto";
import styles from "./styles";

export default withStyles(styles)(Foto);
